<div *ngIf="error">
  {{ error }}
</div>
<div fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutAlign="start"
  fxLayoutGap="20px">


  <div fxFlex="0 0 0">
    <ca-profile-image [file]="form.get('profileImage').value"></ca-profile-image>
  </div>
  <div fxFlex="1 1 0">

    <form [formGroup]="form">
      <div class="input-group">
        <mat-form-field>
          <input matInput
            type="text"
            class="input-wide"
            placeholder="First Name"
            formControlName="firstName">
        </mat-form-field>
        <mat-form-field>
          <input matInput
            type="text"
            class="input-wide"
            placeholder="Last Name"
            formControlName="lastName">
        </mat-form-field>
      </div>
    </form>
    <form [formGroup]="role"
      (submit)="onSubmit()">
      <ca-role-select placeholder="Organisation Role"
        formControlName="role"></ca-role-select>
      <mat-slide-toggle formControlName="enabled">Account Enabled</mat-slide-toggle>
      <p *ngIf="role.get('enabled').value === false">This user's account is disabled. They will not be able to perform any actions for this organisation.</p>
      <div class="input-group">
        <button [disabled]="loading || disabled"
          role="button"
          color="primary"
          mat-flat-button>Save</button>
      </div>
    </form>
  </div>